import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DesignContextProvider } from '@klarna/designtokens';
import * as ParticleDesignVersions from '@bubble-ui/particle-design-versions';
import { ThemeNameProvider } from '@bubble-ui/provider-theme-name';
export var DesignVersionContext = /*#__PURE__*/React.createContext(ParticleDesignVersions.PANCAKE_LIGHT);
DesignVersionContext.displayName = 'DesignVersionContext';
function tokensFromDesignVersion(designVersion) {
  switch (designVersion) {
    case ParticleDesignVersions.PANCAKE_LIGHT:
      return require('@bubble-ui/theme-pancake').lightTheme();
    case ParticleDesignVersions.PANCAKE_DARK:
      return require('@bubble-ui/theme-pancake').darkTheme();
    case ParticleDesignVersions.WAFFLE_LIGHT:
      return require('@bubble-ui/theme-waffle').lightTheme();
    case ParticleDesignVersions.WAFFLE_DARK:
      return require('@bubble-ui/theme-waffle').darkTheme();
    case ParticleDesignVersions.WHITELABEL_LIGHT:
      return require('@bubble-ui/theme-whitelabel').lightTheme();
    case ParticleDesignVersions.WHITELABEL_DARK:
      return require('@bubble-ui/theme-whitelabel').darkTheme();
    default:
      return {};
  }
}
export var Consumer = DesignVersionContext.Consumer;
export var Provider = _ref => {
  var {
    value,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(DesignVersionContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(DesignContextProvider, {
    tokens: tokensFromDesignVersion(value)
  }, /*#__PURE__*/React.createElement(ThemeNameProvider, {
    value: value
  }, children)));
};
Provider.displayName = 'DesignVersionProvider';
export var withDesignVersion = Target => props => /*#__PURE__*/React.createElement(DesignVersionContext.Consumer, null, designVersion => /*#__PURE__*/React.createElement(Target, _extends({}, props, {
  designVersion: designVersion
})));
export var useDesignVersion = () => React.useContext(DesignVersionContext);
//# sourceMappingURL=index.js.map